<!-- {{ checkDetection }} -->
<!-- Embedded XWAI copilot, available on every job page (model, costs, charts,
     files, …). It's a fixed-position floating panel that reads the current
     job/iteration/model from the shared JobStateService, so it stays
     context-aware no matter which job page is open. -->
<app-model-ai-panel></app-model-ai-panel>
<app-sidebar></app-sidebar>
<!-- margin for sidebar distance -->
<div class="page-wrapper">
  @if (project && currentJob && jobs.length > 0 &&{
    project: project,
    currentJob: currentJob,
    jobs: jobs
    }; as data) {
    <section class="project-header">
      <div class="title-line">
        <nz-collapse nzGhost nzSize="small">
          <nz-collapse-panel [nzHeader]="projectHeader" [nzActive]="false">
            <div class="project-description">
              <h4 class="project-description__label">Description</h4>
              @if (currentJob.projectDescription) {
                <p class="project-description__text">{{currentJob.projectDescription}}</p>
              } @else {
                <p class="project-description__empty">No description provided.</p>
              }
            </div>
          </nz-collapse-panel>
        </nz-collapse>
        <ng-template #projectHeader>
          <h1 class="project-title" (click)="goToProject(); $event.stopPropagation()">
            {{currentJob.projectName}}
            <button nz-button nzShape="circle" nzType="text" nzSize="small" (click)="editProject(); $event.stopPropagation()">
              <span nz-icon nzType="edit" nzTheme="outline" nz-tooltip nzTooltipTitle="Edit project"></span>
            </button>
          </h1>
        </ng-template>
        @if (isMobile) {
          <nz-collapse nzGhost nzSize="small" class="actions-collapse">
            <nz-collapse-panel class="parent-job-tag" nzHeader="Parent Job: {{parentJobString}}" [nzActive]="false">
              <div class="header-actions">
                <button nz-button nzType="dashed" [disabled]="!project.archiveEnabled" (click)="toggleKeep()"
                  nzSize="small" [nz-tooltip]="cleanupTime" [nzTooltipTitle]="cleanupTime">
                  <span nz-icon nzType="cloud-sync" nzTheme="outline"></span>
                  Storage Status: {{storageStatusString}}
                </button>
                <button nz-button nzType="dashed" (click)="refreshProjectAndJob()" nzSize="small">
                  <span nz-icon nzType="sync" nzTheme="outline"></span>
                  Refresh Jobs
                </button>
                <button nz-button nzType="dashed" nzSize="small" nz-dropdown [nzDropdownMenu]="addJobMenuMobile"
                  nzTrigger="click" nz-tooltip nzTooltipTitle="Add a new job to this project">
                  <span nz-icon nzType="plus" nzTheme="outline"></span>
                  Add Job
                  <span nz-icon nzType="down" nzTheme="outline"></span>
                </button>
                <nz-dropdown-menu #addJobMenuMobile="nzDropdownMenu">
                  <ul nz-menu>
                    <li nz-menu-item (click)="addJob()">Add existing job</li>
                    <li nz-menu-item (click)="submitNewJob()">Submit new job</li>
                  </ul>
                </nz-dropdown-menu>
              </div>
            </nz-collapse-panel>
          </nz-collapse>
        } @else {
          <div class="header-actions">
            @if (parentJob) {
              <div class="parent-job-tag" nz-tooltip [nzTooltipTitle]="parentJob.name">
                Parent Job: {{parentJobString}}
              </div>
            }
            <button nz-button nzType="dashed" [disabled]="!project.archiveEnabled" (click)="toggleKeep()"
              nzSize="small" [nz-tooltip]="cleanupTime" [nzTooltipTitle]="cleanupTime">
              <span nz-icon nzType="cloud-sync" nzTheme="outline"></span>
              Storage Status: {{storageStatusString}}
            </button>
            <button nz-button nzType="dashed" (click)="refreshProjectAndJob()" nzSize="small">
              <span nz-icon nzType="sync" nzTheme="outline"></span>
              Refresh Jobs
            </button>
            <button nz-button nzType="dashed" nzSize="small" nz-dropdown [nzDropdownMenu]="addJobMenu"
              nzTrigger="click" nz-tooltip nzTooltipTitle="Add a new job to this project">
              <span nz-icon nzType="plus" nzTheme="outline"></span>
              Add Job
              <span nz-icon nzType="down" nzTheme="outline"></span>
            </button>
            <nz-dropdown-menu #addJobMenu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item (click)="addJob()">Add existing job</li>
                <li nz-menu-item (click)="submitNewJob()">Submit new job</li>
              </ul>
            </nz-dropdown-menu>
          </div>
          <label nz-checkbox [(ngModel)]="jobState.synchroniseSettings" (ngModelChange)="onSynchroniseChange($event)">
            <span>Synchronise Settings</span>
          </label>
        }
      </div>
      @if (isMobile) {
        <label nz-checkbox [(ngModel)]="jobState.synchroniseSettings" (ngModelChange)="onSynchroniseChange($event)">
          <span>Synchronise Settings</span>
        </label>
      }
    </section>
    <section id="scroll-anchor" #anchor>
      <div class="fav-tabs-container">
        <nav mat-tab-nav-bar [tabPanel]="jobPanel">
          @for (job of favJobs; track trackByJobId(i, job); let i = $index) {
            <a mat-tab-link
              (keydown.arrowleft)="onIndexChangedHandler(i - 1, 'fav')"
              (keydown.arrowright)="onIndexChangedHandler(i + 1, 'fav')"
              (click)="onIndexChangedHandler(i, 'fav')"
              [active]="currentJob?.id === job.id">
              {{ job.name }}
            </a>
          }
        </nav>
        <div class="tab-action-buttons">
          <button (click)="addToFav()"><i class="zmdi zmdi-plus"></i></button>
          <button [disabled]="!hasFavJobs" (click)="removeFromFav()"><i class="zmdi zmdi-minus"></i></button>
          <button [disabled]="!hasFavJobs" (click)="shiftLeft()"><i class="zmdi zmdi-arrow-back"></i></button>
          <button [disabled]="!hasFavJobs" (click)="shiftRight()"><i
          class="zmdi zmdi-arrow-forward"></i></button>
        </div>
      </div>
      <div class="main-tabs-row">
        <div class="tabs-column" [ngStyle]="{ marginLeft: hasFavJobs ? '0' : '20px' }">
          <nav mat-tab-nav-bar [tabPanel]="jobPanel">
            @for (job of jobs; track trackByJobId(i, job); let i = $index) {
              <a mat-tab-link
                (keydown.arrowleft)="debouncedIndexChangeHandler(i - 1, 'all')"
                (keydown.arrowright)="debouncedIndexChangeHandler(i + 1, 'all')"
                (click)="onIndexChangedHandler(i, 'all')"
                [active]="currentJob?.id === job.id">
                {{ job.name }}
              </a>
            }
          </nav>
        </div>
        <div class="select-column">
          <nz-input-group class="custom-floating-label job-select-group">
            <label>Selected Job</label>
            <nz-select [ngModel]="currentJob" (ngModelChange)="selectChangeHandler($event)"
              [compareWith]="compareFn" nzShowSearch>
              @for (job of jobs; track trackByJobId($index, job)) {
                <nz-option [nzLabel]="job.name" [nzValue]="job" nzCustomContent>
                                <span class="job-type-marker" [style.backgroundColor]="
                                job.type == 'QC'
                                    ? 'oklch(90.5% 0.182 98.111)'
                                    : job.type == 'SC'
                                    ? 'oklch(58.6% 0.253 17.585)'
                                    : job.type == 'standard'
                                    ? '#2196F3'
                                    : job.type == 'RWI'
                                    ? 'oklch(75% 0.183 55.934)'
                                    : 'oklch(69.6% 0.17 162.48)'
                                "></span>
                  {{job.name}}
                </nz-option>
              }
            </nz-select>
            <button nz-button nz-tooltip nzTooltipTitle="Open job group" nz-dropdown [nzDropdownMenu]="groupsMenu">
              <span nz-icon nzType="ellipsis"></span>
            </button>
          </nz-input-group>
          <button nz-button nzShape="circle" nzType="text" nzSize="small" (click)="editJob()" class="edit-job-btn">
            <span nz-icon nzType="edit" nzTheme="outline" nz-tooltip nzTooltipTitle="Edit job"></span>
          </button>
        </div>
      </div>
    </section>
    <mat-tab-nav-panel #jobPanel>
      <div class="content-area">
        <router-outlet></router-outlet>
      </div>
    </mat-tab-nav-panel>
    @if (!isMobile) {  
      <!-- this is the bottom section for when we want it to come up after scrolling -->
      <div id="job-tabs-bottom" class="scroll-component" [class.is-visible]="bottomTabsVisible">
        <div class="bottom-tabs-bg">
          <div class="fav-tabs-container">
            <nav mat-tab-nav-bar [tabPanel]="jobPanel">
              @for (job of favJobs; track trackByJobId(i, job); let i = $index) {
                <a mat-tab-link
                  (keydown.arrowleft)="onIndexChangedHandler(i - 1, 'fav')"
                  (keydown.arrowright)="onIndexChangedHandler(i + 1, 'fav')"
                  (click)="onIndexChangedHandler(i, 'fav')"
                  [active]="currentJob?.id === job.id">
                  {{ job.name }}
                </a>
              }
            </nav>
            <div class="tab-action-buttons"><button (click)="addToFav()"><i class="zmdi zmdi-plus"></i></button>
            <button [disabled]="!hasFavJobs" (click)="removeFromFav()"><i
            class="zmdi zmdi-minus"></i></button>
            <button [disabled]="!hasFavJobs" (click)="shiftLeft()"><i
            class="zmdi zmdi-arrow-back"></i></button>
            <button [disabled]="!hasFavJobs" (click)="shiftRight()"><i
            class="zmdi zmdi-arrow-forward"></i></button>
          </div>
        </div>
        <div class="bottom-tabs-row">
          <div class="tabs-column" [ngStyle]="{ marginLeft: hasFavJobs ? '0' : '20px', borderTop: hasFavJobs ? '1px solid #ccc' : '' }">
            <nav mat-tab-nav-bar [tabPanel]="jobPanel">
              @for (job of jobs; track trackByJobId(i, job); let i = $index) {
                <a mat-tab-link
                  (keydown.arrowleft)="debouncedIndexChangeHandler(i - 1, 'all')"
                  (keydown.arrowright)="debouncedIndexChangeHandler(i + 1, 'all')"
                  (click)="onIndexChangedHandler(i, 'all')" [active]="currentJob?.id === job.id">
                  {{ job.name }}
                </a>
              }
            </nav>
          </div>
          <div class="sync-settings-column">
            <!-- <label nz-checkbox [ngModel]="syncSettings$ | async" (ngModelChange)="onSynchroniseChange($event)"> -->
            <label nz-checkbox [(ngModel)]="jobState.synchroniseSettings" (ngModelChange)="onSynchroniseChange($event)">
              <span>Synchronise Settings</span>
            </label>
          </div>
        </div>
      </div>
      </div>
    }
  } @else {
    @if (error) {
      <nz-alert nzType="error" nzMessage="Error loading job.." [nzDescription]="error" ></nz-alert>
    } @else {
      <nz-card class="loading-card">
        <nz-spin nzSize="large" nzTip="Loading jobs and projects..."></nz-spin>
      </nz-card>
    }
  }

</div>




<nz-dropdown-menu #groupsMenu="nzDropdownMenu">
  <ul nz-menu>
    @if(jobGroups$ | async; as groups){
      @for (group of groups; track group.id){
        <li nz-submenu [nzTitle]="group.name" [nzClickHide]="false"
          (click)="onGroupClick(group)">
          <ul>
            @for (job of group.jobs; track job.id) {
              <li nz-menu-item [nzDisabled]="true">
                {{ job.job__job_name }}
              </li>
            }
          </ul>
        </li>
      }
    }
  </ul>
</nz-dropdown-menu>
